/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createDetailFieldHook } from '../../core/factories/createDetailFieldHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetWinnerRow } from '../openapi-types.gen.js';
import { type useGetWinnerArgs, useGetWinnerSpec, useGetWinnerRealtime } from '../specs/winners.spec.gen.js';

export type { GetWinnerRow } from '../openapi-types.gen.js';
export type { useGetWinnerArgs } from '../specs/winners.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): outcomeMint.
 */
const _useGetWinner = createHook(useGetWinnerSpec, useGetWinnerRealtime);
export const useGetWinner = _useGetWinner as (args: useGetWinnerArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetWinner>;


/**
 * Per-field subscription hook for the \`useGetWinner\` cache entry.
 * Pass the SAME args as the parent hook (same queryKey → same cache). Returns the named field's value; only the call site
 * re-renders when that field changes (TanStack tracked-properties +
 * per-component `select`).
 *
 *     function Title({ pubkey }) {
 *       const value = useGetWinnerField({ pubkey }, 'title');
 *       return <h3>{value}</h3>;
 *     }
 */
export const useGetWinnerField = createDetailFieldHook(useGetWinnerSpec);

/**
 * Hover/intent prefetch companion for `useGetWinner`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetWinner();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetWinner = createPrefetchHook(useGetWinnerSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetWinnerArgs>;
